import { importProvidersFrom, ApplicationConfig, inject } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withRouterConfig, withViewTransitions, Router, isActive } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { provideAnimations } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { AppModule, tokenGetter } from './app.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';

Sentry.init({
  environment: environment.environmentName,
  dsn: 'https://2e05ba60a9dfeae9289f9e4655068a60@o4508206329495552.ingest.de.sentry.io/4508206382252112',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  sendClientReports: false,
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideRouter(
      routes,
      // withDebugTracing(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
      withViewTransitions({
        skipInitialTransition: true,
        onViewTransitionCreated: ({ transition }) => {
          const router = inject(Router);
          const targetUrl = router.currentNavigation()!.finalUrl!;
          const isSameRoute = isActive(targetUrl, router, {
            paths: 'exact',
            matrixParams: 'exact',
            fragment: 'ignored',
            queryParams: 'ignored',
          });
          if (isSameRoute()) {
            transition.skipTransition();
          }
        },
      }),
    ),
    importProvidersFrom(AppModule),
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    importProvidersFrom(
      JwtModule.forRoot({
        config: {
          tokenGetter: tokenGetter,
        },
      }),
    ),
    provideHttpClient(withInterceptorsFromDi()),
  ],
};
